import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
// ngrx store
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// model
import { AppState } from '../../../booking/models/app-state.interface';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-translation-loader',
  templateUrl: './translation-loader.component.html',
  styleUrls: ['./translation-loader.component.scss']
})
export class TranslationLoaderComponent implements OnInit, OnDestroy {

  private _copyInitSubscription: Subscription;

  public showAppLoader = true;


  constructor(
    private _appStore: Store<AppState>,

    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          const isBookingFlow = window.location.pathname.includes('/abc/') || window.location.pathname.includes('/ccd/');
          const isLoaded = isBookingFlow ? (res.copyLoaded && res.rulesCopyLoaded) : res.copyLoaded;

          if (isLoaded) {
            const body = document.getElementsByTagName('body')[0];
            body.classList.remove('modal-open');
            body.style.overflow = 'auto';
            this.showAppLoader = false;
          }
        });

    }


  }

  ngOnDestroy() {
    if (this._copyInitSubscription) { this._copyInitSubscription.unsubscribe(); }
  }

}
